export default __webpack_public_path__ + "static/blob2-d702e1010019783a9c443ba2347b2b8d.svg";